import { FixIt } from 'resources/index';

import { OrganizationPayload } from 'components/Leads/hooks/useOrganization';
import { OrganizationAddress } from 'components/PayWall/Redux/Actions';

import RestAPI from '../../components/Common/restApi';

export default class OrganizationApi {
  static fetchOrganization() {
    const requestUrl = '/api/v2/organization';
    return RestAPI.get<OrganizationPayload>(requestUrl);
  }

  static updateOrganization(form_data: OrganizationAddress) {
    const reqUrl = '/api/v2/organization';
    return RestAPI.updateWithFormData<OrganizationAddress, OrganizationAddress>(reqUrl, form_data);
  }

  static getOrganizationProfile(expand = []) {
    return RestAPI.getWithFormData('/alpha/organization/profile', expand);
  }

  static updateOrganizationProfile(profile: never) {
    return RestAPI.updateWithFormData('/alpha/organization/profile', profile);
  }

  static updateLogo(file: FixIt) {
    const formData = new FormData();
    formData.append('file', file);

    return RestAPI.updateWithFormData('/alpha/organization/logo', formData);
  }

  static fetchDispatchablePros() {
    return RestAPI.get('/alpha/organization/dispatchable_pros');
  }

  static fetchOrganizationInterests() {
    return RestAPI.get('/alpha/organization/interests');
  }

  static updateOrganizationInterests(form_data: FixIt) {
    return RestAPI.updateWithFormData('/alpha/organization/interests', form_data);
  }

  static createEmployee(form_data: FixIt) {
    return RestAPI.postWithFormData('/alpha/organization/employees', form_data);
  }

  static moveBilling(orgId: string, form_data: FixIt) {
    const reqUrl = `/admin/organizations/${orgId}/move_billing_to_another_org`;
    return RestAPI.postWithFormData(reqUrl, form_data);
  }

  static movePayment(orgId: string, form_data: FixIt) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/move_payment_to_another_job`, form_data);
  }

  static moveLendingPayment(orgId: string, formData: FixIt) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/move_lending_payment`, formData);
  }

  static updateTipAmount(orgId: string, form_data: FixIt) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/update_tip_amount`, form_data);
  }

  static resetInvoiceNumbers(orgId: string, form_data: FixIt) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/reset_invoice_numbers`, form_data);
  }

  static pushToQbo(orgId: string) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/push_to_qbo`);
  }

  static removeQboImport(orgId: string) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/remove_qbo_import`);
  }

  static deleteQuickbooksDesktopImport(orgId: string) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/delete_quickbooks_desktop_import`);
  }

  static restartQuickbooksDesktopProcessing(orgId: string) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/restart_quickbooks_desktop_processing`);
  }

  static reprocessAllQuickbooksOnlineErrors(orgId: string) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/reprocess_all_quickbooks_online_errors`);
  }

  static releaseSms(orgId: string) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/release_sms`);
  }

  static archivePriceList(orgId: string) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/archive_price_list`);
  }

  static archivePriceListWithoutMaterials(orgId: string) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/archive_price_list_without_materials`);
  }

  static archivePriceListWithoutPricingContent(orgId: string) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/archive_price_list_without_pricing_content`);
  }

  static restorePriceList(orgId: string) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/restore_price_list`);
  }

  static restorePricingContent(orgId: string) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/restore_pricing_content`);
  }

  static copyPricingContentBook(params: FixIt, uuid: string) {
    return RestAPI.postWithFormData(`/admin/pricing_content/books/${uuid}/copy`, params);
  }

  static removePricingContentBook(params: FixIt, uuid: string) {
    return RestAPI.deleteWithFormData(`/admin/pricing_content/books/${uuid}/remove`, params);
  }

  static deleteImportedCustomers(orgId: string) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/delete_imported_customers`);
  }

  static endInAppSubscription(orgId: string) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/end_in_app_subscription`);
  }

  static addTimeTrackingDashboardReport(orgId: string) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/add_time_tracking_dashboard_report`);
  }

  static toggleStripePayoutSchedule(orgId: string) {
    return RestAPI.postWithFormData(`/admin/organizations/${orgId}/toggle_stripe_payout_schedule`);
  }
}
